// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "helcim.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "helcim.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Per-card lifecycle relative to server time when the RPC runs.
 *
 * @generated from protobuf enum CardStatus
 */
export var CardStatus;
(function (CardStatus) {
    /**
     * @generated from protobuf enum value: CARD_STATUS_UNSPECIFIED = 0;
     */
    CardStatus[CardStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CARD_STATUS_ACTIVE = 1;
     */
    CardStatus[CardStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * expires within 30 days (still valid)
     *
     * @generated from protobuf enum value: CARD_STATUS_EXPIRING_SOON = 2;
     */
    CardStatus[CardStatus["EXPIRING_SOON"] = 2] = "EXPIRING_SOON";
    /**
     * @generated from protobuf enum value: CARD_STATUS_EXPIRED = 3;
     */
    CardStatus[CardStatus["EXPIRED"] = 3] = "EXPIRED";
})(CardStatus || (CardStatus = {}));
/**
 * Roll-up for UI chip. NOT_LINKED = Kalos billing is Card On File but Helcim has no customer for user_id.
 *
 * @generated from protobuf enum AggregateCardStatus
 */
export var AggregateCardStatus;
(function (AggregateCardStatus) {
    /**
     * @generated from protobuf enum value: AGG_STATUS_UNSPECIFIED = 0;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_UNSPECIFIED"] = 0] = "AGG_STATUS_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: AGG_STATUS_NONE_ON_FILE = 1;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_NONE_ON_FILE"] = 1] = "AGG_STATUS_NONE_ON_FILE";
    /**
     * @generated from protobuf enum value: AGG_STATUS_ACTIVE = 2;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_ACTIVE"] = 2] = "AGG_STATUS_ACTIVE";
    /**
     * @generated from protobuf enum value: AGG_STATUS_EXPIRING_SOON = 3;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_EXPIRING_SOON"] = 3] = "AGG_STATUS_EXPIRING_SOON";
    /**
     * @generated from protobuf enum value: AGG_STATUS_ALL_EXPIRED = 4;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_ALL_EXPIRED"] = 4] = "AGG_STATUS_ALL_EXPIRED";
    /**
     * @generated from protobuf enum value: AGG_STATUS_NOT_LINKED = 5;
     */
    AggregateCardStatus[AggregateCardStatus["AGG_STATUS_NOT_LINKED"] = 5] = "AGG_STATUS_NOT_LINKED";
})(AggregateCardStatus || (AggregateCardStatus = {}));
/**
 * ProfileLinkState reflects whether a Helcim profile's customerCode already maps it to a Kalos user.
 * The Kalos<->Helcim convention is customerCode == user_id; Helcim auto-generated codes are
 * non-numeric and count as UNLINKED (free to link).
 *
 * @generated from protobuf enum ProfileLinkState
 */
export var ProfileLinkState;
(function (ProfileLinkState) {
    /**
     * @generated from protobuf enum value: PROFILE_LINK_UNSPECIFIED = 0;
     */
    ProfileLinkState[ProfileLinkState["PROFILE_LINK_UNSPECIFIED"] = 0] = "PROFILE_LINK_UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PROFILE_LINK_UNLINKED = 1;
     */
    ProfileLinkState[ProfileLinkState["PROFILE_LINK_UNLINKED"] = 1] = "PROFILE_LINK_UNLINKED";
    /**
     * @generated from protobuf enum value: PROFILE_LINK_THIS_USER = 2;
     */
    ProfileLinkState[ProfileLinkState["PROFILE_LINK_THIS_USER"] = 2] = "PROFILE_LINK_THIS_USER";
    /**
     * @generated from protobuf enum value: PROFILE_LINK_OTHER_USER = 3;
     */
    ProfileLinkState[ProfileLinkState["PROFILE_LINK_OTHER_USER"] = 3] = "PROFILE_LINK_OTHER_USER";
})(ProfileLinkState || (ProfileLinkState = {}));
// @generated message type with reflection information, may provide speed optimized methods
class CheckoutReq$Type extends MessageType {
    constructor() {
        super("CheckoutReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "allow_partial", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "digital_wallet", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "confirmation_screen", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.invoiceId = 0;
        message.amount = 0;
        message.allowPartial = 0;
        message.paymentType = "";
        message.currency = "";
        message.paymentMethod = "";
        message.digitalWallet = "";
        message.confirmationScreen = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 invoice_id */ 2:
                    message.invoiceId = reader.int32();
                    break;
                case /* float amount */ 3:
                    message.amount = reader.float();
                    break;
                case /* float allow_partial */ 4:
                    message.allowPartial = reader.float();
                    break;
                case /* string payment_type */ 5:
                    message.paymentType = reader.string();
                    break;
                case /* string currency */ 6:
                    message.currency = reader.string();
                    break;
                case /* string payment_method */ 7:
                    message.paymentMethod = reader.string();
                    break;
                case /* string digital_wallet */ 8:
                    message.digitalWallet = reader.string();
                    break;
                case /* bool confirmation_screen */ 9:
                    message.confirmationScreen = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 invoice_id = 2; */
        if (message.invoiceId !== 0)
            writer.tag(2, WireType.Varint).int32(message.invoiceId);
        /* float amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit32).float(message.amount);
        /* float allow_partial = 4; */
        if (message.allowPartial !== 0)
            writer.tag(4, WireType.Bit32).float(message.allowPartial);
        /* string payment_type = 5; */
        if (message.paymentType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentType);
        /* string currency = 6; */
        if (message.currency !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.currency);
        /* string payment_method = 7; */
        if (message.paymentMethod !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.paymentMethod);
        /* string digital_wallet = 8; */
        if (message.digitalWallet !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.digitalWallet);
        /* bool confirmation_screen = 9; */
        if (message.confirmationScreen !== false)
            writer.tag(9, WireType.Varint).bool(message.confirmationScreen);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckoutReq
 */
export const CheckoutReq = new CheckoutReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyCardCheckoutReq$Type extends MessageType {
    constructor() {
        super("VerifyCardCheckoutReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "digital_wallet", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "confirmation_screen", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.paymentMethod = "";
        message.currency = "";
        message.digitalWallet = "";
        message.confirmationScreen = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string payment_method */ 2:
                    message.paymentMethod = reader.string();
                    break;
                case /* string currency */ 3:
                    message.currency = reader.string();
                    break;
                case /* string digital_wallet */ 4:
                    message.digitalWallet = reader.string();
                    break;
                case /* bool confirmation_screen */ 5:
                    message.confirmationScreen = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string payment_method = 2; */
        if (message.paymentMethod !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentMethod);
        /* string currency = 3; */
        if (message.currency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currency);
        /* string digital_wallet = 4; */
        if (message.digitalWallet !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.digitalWallet);
        /* bool confirmation_screen = 5; */
        if (message.confirmationScreen !== false)
            writer.tag(5, WireType.Varint).bool(message.confirmationScreen);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyCardCheckoutReq
 */
export const VerifyCardCheckoutReq = new VerifyCardCheckoutReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckoutResp$Type extends MessageType {
    constructor() {
        super("CheckoutResp", [
            { no: 1, name: "checkout_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.checkoutToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string checkout_token */ 1:
                    message.checkoutToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string checkout_token = 1; */
        if (message.checkoutToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.checkoutToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckoutResp
 */
export const CheckoutResp = new CheckoutResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApiToken$Type extends MessageType {
    constructor() {
        super("ApiToken", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ApiToken
 */
export const ApiToken = new ApiToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimEvent$Type extends MessageType {
    constructor() {
        super("HelcimEvent", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "helcim_transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "event_created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "partial_payment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "helcim_invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "capture_mode", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.helcimTransactionId = 0;
        message.invoiceId = 0;
        message.userId = 0;
        message.paymentType = "";
        message.paymentMethod = "";
        message.status = "";
        message.currency = "";
        message.amount = 0;
        message.eventCreatedAt = "";
        message.errorMessage = "";
        message.partialPayment = false;
        message.fieldMask = [];
        message.helcimInvoiceNumber = "";
        message.deviceId = "";
        message.captureMode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 helcim_transaction_id */ 2:
                    message.helcimTransactionId = reader.int32();
                    break;
                case /* int32 invoice_id */ 3:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 user_id */ 4:
                    message.userId = reader.int32();
                    break;
                case /* string payment_type */ 5:
                    message.paymentType = reader.string();
                    break;
                case /* string payment_method */ 6:
                    message.paymentMethod = reader.string();
                    break;
                case /* string status */ 7:
                    message.status = reader.string();
                    break;
                case /* string currency */ 8:
                    message.currency = reader.string();
                    break;
                case /* float amount */ 9:
                    message.amount = reader.float();
                    break;
                case /* string event_created_at */ 10:
                    message.eventCreatedAt = reader.string();
                    break;
                case /* string error_message */ 11:
                    message.errorMessage = reader.string();
                    break;
                case /* bool partial_payment */ 12:
                    message.partialPayment = reader.bool();
                    break;
                case /* repeated string field_mask */ 13:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string helcim_invoice_number */ 14:
                    message.helcimInvoiceNumber = reader.string();
                    break;
                case /* string device_id */ 15:
                    message.deviceId = reader.string();
                    break;
                case /* string capture_mode */ 16:
                    message.captureMode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 helcim_transaction_id = 2; */
        if (message.helcimTransactionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.helcimTransactionId);
        /* int32 invoice_id = 3; */
        if (message.invoiceId !== 0)
            writer.tag(3, WireType.Varint).int32(message.invoiceId);
        /* int32 user_id = 4; */
        if (message.userId !== 0)
            writer.tag(4, WireType.Varint).int32(message.userId);
        /* string payment_type = 5; */
        if (message.paymentType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentType);
        /* string payment_method = 6; */
        if (message.paymentMethod !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.paymentMethod);
        /* string status = 7; */
        if (message.status !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.status);
        /* string currency = 8; */
        if (message.currency !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.currency);
        /* float amount = 9; */
        if (message.amount !== 0)
            writer.tag(9, WireType.Bit32).float(message.amount);
        /* string event_created_at = 10; */
        if (message.eventCreatedAt !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.eventCreatedAt);
        /* string error_message = 11; */
        if (message.errorMessage !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.errorMessage);
        /* bool partial_payment = 12; */
        if (message.partialPayment !== false)
            writer.tag(12, WireType.Varint).bool(message.partialPayment);
        /* repeated string field_mask = 13; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string helcim_invoice_number = 14; */
        if (message.helcimInvoiceNumber !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.helcimInvoiceNumber);
        /* string device_id = 15; */
        if (message.deviceId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.deviceId);
        /* string capture_mode = 16; */
        if (message.captureMode !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.captureMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimEvent
 */
export const HelcimEvent = new HelcimEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimEventList$Type extends MessageType {
    constructor() {
        super("HelcimEventList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimEvent },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated HelcimEvent results */ 1:
                    message.results.push(HelcimEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated HelcimEvent results = 1; */
        for (let i = 0; i < message.results.length; i++)
            HelcimEvent.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimEventList
 */
export const HelcimEventList = new HelcimEventList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardAuthorization$Type extends MessageType {
    constructor() {
        super("HelcimCardAuthorization", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "basis_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "authorized_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.cardToken = "";
        message.basisTypeId = 0;
        message.authorizedBy = 0;
        message.createdAt = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string card_token */ 3:
                    message.cardToken = reader.string();
                    break;
                case /* int32 basis_type_id */ 4:
                    message.basisTypeId = reader.int32();
                    break;
                case /* int32 authorized_by */ 5:
                    message.authorizedBy = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string card_token = 3; */
        if (message.cardToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cardToken);
        /* int32 basis_type_id = 4; */
        if (message.basisTypeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.basisTypeId);
        /* int32 authorized_by = 5; */
        if (message.authorizedBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.authorizedBy);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardAuthorization
 */
export const HelcimCardAuthorization = new HelcimCardAuthorization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardAuthorizationList$Type extends MessageType {
    constructor() {
        super("HelcimCardAuthorizationList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimCardAuthorization },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated HelcimCardAuthorization results */ 1:
                    message.results.push(HelcimCardAuthorization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated HelcimCardAuthorization results = 1; */
        for (let i = 0; i < message.results.length; i++)
            HelcimCardAuthorization.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardAuthorizationList
 */
export const HelcimCardAuthorizationList = new HelcimCardAuthorizationList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardAudit$Type extends MessageType {
    constructor() {
        super("HelcimCardAudit", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "acting_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "audit_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "basis_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.actingUserId = 0;
        message.auditTypeId = 0;
        message.cardToken = "";
        message.basisTypeId = 0;
        message.note = "";
        message.createdAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 acting_user_id */ 3:
                    message.actingUserId = reader.int32();
                    break;
                case /* int32 audit_type_id */ 4:
                    message.auditTypeId = reader.int32();
                    break;
                case /* string card_token */ 5:
                    message.cardToken = reader.string();
                    break;
                case /* int32 basis_type_id */ 6:
                    message.basisTypeId = reader.int32();
                    break;
                case /* string note */ 7:
                    message.note = reader.string();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 acting_user_id = 3; */
        if (message.actingUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.actingUserId);
        /* int32 audit_type_id = 4; */
        if (message.auditTypeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.auditTypeId);
        /* string card_token = 5; */
        if (message.cardToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cardToken);
        /* int32 basis_type_id = 6; */
        if (message.basisTypeId !== 0)
            writer.tag(6, WireType.Varint).int32(message.basisTypeId);
        /* string note = 7; */
        if (message.note !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.note);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardAudit
 */
export const HelcimCardAudit = new HelcimCardAudit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardAuditList$Type extends MessageType {
    constructor() {
        super("HelcimCardAuditList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimCardAudit },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated HelcimCardAudit results */ 1:
                    message.results.push(HelcimCardAudit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated HelcimCardAudit results = 1; */
        for (let i = 0; i < message.results.length; i++)
            HelcimCardAudit.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardAuditList
 */
export const HelcimCardAuditList = new HelcimCardAuditList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardLink$Type extends MessageType {
    constructor() {
        super("HelcimCardLink", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "recipient_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sent_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "canceled_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "completed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "expires_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.userId = 0;
        message.recipientEmail = "";
        message.sentBy = 0;
        message.canceledAt = "";
        message.completedAt = "";
        message.expiresAt = "";
        message.createdAt = "";
        message.updatedAt = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* string recipient_email */ 3:
                    message.recipientEmail = reader.string();
                    break;
                case /* int32 sent_by */ 4:
                    message.sentBy = reader.int32();
                    break;
                case /* string canceled_at */ 5:
                    message.canceledAt = reader.string();
                    break;
                case /* string completed_at */ 6:
                    message.completedAt = reader.string();
                    break;
                case /* string expires_at */ 7:
                    message.expiresAt = reader.string();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 9:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* string recipient_email = 3; */
        if (message.recipientEmail !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.recipientEmail);
        /* int32 sent_by = 4; */
        if (message.sentBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.sentBy);
        /* string canceled_at = 5; */
        if (message.canceledAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.canceledAt);
        /* string completed_at = 6; */
        if (message.completedAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.completedAt);
        /* string expires_at = 7; */
        if (message.expiresAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.expiresAt);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 9; */
        if (message.updatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardLink
 */
export const HelcimCardLink = new HelcimCardLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCardOnFileLinkReq$Type extends MessageType {
    constructor() {
        super("CreateCardOnFileLinkReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateCardOnFileLinkReq
 */
export const CreateCardOnFileLinkReq = new CreateCardOnFileLinkReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardOnFileLinkResp$Type extends MessageType {
    constructor() {
        super("CardOnFileLinkResp", [
            { no: 1, name: "link_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "recipient_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.linkId = 0;
        message.url = "";
        message.recipientEmail = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 link_id */ 1:
                    message.linkId = reader.int32();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* string recipient_email */ 3:
                    message.recipientEmail = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 link_id = 1; */
        if (message.linkId !== 0)
            writer.tag(1, WireType.Varint).int32(message.linkId);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* string recipient_email = 3; */
        if (message.recipientEmail !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.recipientEmail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CardOnFileLinkResp
 */
export const CardOnFileLinkResp = new CardOnFileLinkResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCardLinkStatusReq$Type extends MessageType {
    constructor() {
        super("GetCardLinkStatusReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetCardLinkStatusReq
 */
export const GetCardLinkStatusReq = new GetCardLinkStatusReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardLinkStatus$Type extends MessageType {
    constructor() {
        super("CardLinkStatus", [
            { no: 1, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "link_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "recipient_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sent_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.active = false;
        message.linkId = 0;
        message.recipientEmail = "";
        message.sentAt = "";
        message.completed = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool active */ 1:
                    message.active = reader.bool();
                    break;
                case /* int32 link_id */ 2:
                    message.linkId = reader.int32();
                    break;
                case /* string recipient_email */ 3:
                    message.recipientEmail = reader.string();
                    break;
                case /* string sent_at */ 4:
                    message.sentAt = reader.string();
                    break;
                case /* bool completed */ 5:
                    message.completed = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool active = 1; */
        if (message.active !== false)
            writer.tag(1, WireType.Varint).bool(message.active);
        /* int32 link_id = 2; */
        if (message.linkId !== 0)
            writer.tag(2, WireType.Varint).int32(message.linkId);
        /* string recipient_email = 3; */
        if (message.recipientEmail !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.recipientEmail);
        /* string sent_at = 4; */
        if (message.sentAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sentAt);
        /* bool completed = 5; */
        if (message.completed !== false)
            writer.tag(5, WireType.Varint).bool(message.completed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CardLinkStatus
 */
export const CardLinkStatus = new CardLinkStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendCardOnFileLinkReq$Type extends MessageType {
    constructor() {
        super("ResendCardOnFileLinkReq", [
            { no: 1, name: "link_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.linkId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 link_id */ 1:
                    message.linkId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 link_id = 1; */
        if (message.linkId !== 0)
            writer.tag(1, WireType.Varint).int32(message.linkId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResendCardOnFileLinkReq
 */
export const ResendCardOnFileLinkReq = new ResendCardOnFileLinkReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelCardOnFileLinkReq$Type extends MessageType {
    constructor() {
        super("CancelCardOnFileLinkReq", [
            { no: 1, name: "link_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.linkId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 link_id */ 1:
                    message.linkId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 link_id = 1; */
        if (message.linkId !== 0)
            writer.tag(1, WireType.Varint).int32(message.linkId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelCardOnFileLinkReq
 */
export const CancelCardOnFileLinkReq = new CancelCardOnFileLinkReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizeCardsReq$Type extends MessageType {
    constructor() {
        super("AuthorizeCardsReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "card_tokens", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "basis_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.cardTokens = [];
        message.basisTypeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* repeated string card_tokens */ 2:
                    message.cardTokens.push(reader.string());
                    break;
                case /* int32 basis_type_id */ 3:
                    message.basisTypeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* repeated string card_tokens = 2; */
        for (let i = 0; i < message.cardTokens.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.cardTokens[i]);
        /* int32 basis_type_id = 3; */
        if (message.basisTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.basisTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AuthorizeCardsReq
 */
export const AuthorizeCardsReq = new AuthorizeCardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompleteCardSaveReq$Type extends MessageType {
    constructor() {
        super("CompleteCardSaveReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CompleteCardSaveReq
 */
export const CompleteCardSaveReq = new CompleteCardSaveReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicCardLinkReq$Type extends MessageType {
    constructor() {
        super("PublicCardLinkReq", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicCardLinkReq
 */
export const PublicCardLinkReq = new PublicCardLinkReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicCardActionReq$Type extends MessageType {
    constructor() {
        super("PublicCardActionReq", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.cardToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string card_token */ 2:
                    message.cardToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string card_token = 2; */
        if (message.cardToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cardToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicCardActionReq
 */
export const PublicCardActionReq = new PublicCardActionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicCardLinkData$Type extends MessageType {
    constructor() {
        super("PublicCardLinkData", [
            { no: 1, name: "customer_first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimCard },
            { no: 3, name: "checkout_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "canceled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerFirstName = "";
        message.cards = [];
        message.checkoutToken = "";
        message.canceled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_first_name */ 1:
                    message.customerFirstName = reader.string();
                    break;
                case /* repeated HelcimCard cards */ 2:
                    message.cards.push(HelcimCard.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string checkout_token */ 3:
                    message.checkoutToken = reader.string();
                    break;
                case /* bool canceled */ 4:
                    message.canceled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_first_name = 1; */
        if (message.customerFirstName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerFirstName);
        /* repeated HelcimCard cards = 2; */
        for (let i = 0; i < message.cards.length; i++)
            HelcimCard.internalBinaryWrite(message.cards[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string checkout_token = 3; */
        if (message.checkoutToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.checkoutToken);
        /* bool canceled = 4; */
        if (message.canceled !== false)
            writer.tag(4, WireType.Varint).bool(message.canceled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicCardLinkData
 */
export const PublicCardLinkData = new PublicCardLinkData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCardsOnFileReq$Type extends MessageType {
    constructor() {
        super("ListCardsOnFileReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListCardsOnFileReq
 */
export const ListCardsOnFileReq = new ListCardsOnFileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPreferredHelcimCardReq$Type extends MessageType {
    constructor() {
        super("SetPreferredHelcimCardReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.cardToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string card_token */ 2:
                    message.cardToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string card_token = 2; */
        if (message.cardToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cardToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetPreferredHelcimCardReq
 */
export const SetPreferredHelcimCardReq = new SetPreferredHelcimCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCard$Type extends MessageType {
    constructor() {
        super("HelcimCard", [
            { no: 1, name: "token_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "exp_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "exp_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "status", kind: "enum", T: () => ["CardStatus", CardStatus, "CARD_STATUS_"] },
            { no: 7, name: "authorized", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "authorization_basis_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "authorized_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tokenId = "";
        message.brand = "";
        message.last4 = "";
        message.expMonth = 0;
        message.expYear = 0;
        message.status = 0;
        message.authorized = false;
        message.authorizationBasisId = 0;
        message.authorizedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token_id */ 1:
                    message.tokenId = reader.string();
                    break;
                case /* string brand */ 2:
                    message.brand = reader.string();
                    break;
                case /* string last4 */ 3:
                    message.last4 = reader.string();
                    break;
                case /* int32 exp_month */ 4:
                    message.expMonth = reader.int32();
                    break;
                case /* int32 exp_year */ 5:
                    message.expYear = reader.int32();
                    break;
                case /* CardStatus status */ 6:
                    message.status = reader.int32();
                    break;
                case /* bool authorized */ 7:
                    message.authorized = reader.bool();
                    break;
                case /* int32 authorization_basis_id */ 8:
                    message.authorizationBasisId = reader.int32();
                    break;
                case /* string authorized_at */ 9:
                    message.authorizedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token_id = 1; */
        if (message.tokenId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tokenId);
        /* string brand = 2; */
        if (message.brand !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.brand);
        /* string last4 = 3; */
        if (message.last4 !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.last4);
        /* int32 exp_month = 4; */
        if (message.expMonth !== 0)
            writer.tag(4, WireType.Varint).int32(message.expMonth);
        /* int32 exp_year = 5; */
        if (message.expYear !== 0)
            writer.tag(5, WireType.Varint).int32(message.expYear);
        /* CardStatus status = 6; */
        if (message.status !== 0)
            writer.tag(6, WireType.Varint).int32(message.status);
        /* bool authorized = 7; */
        if (message.authorized !== false)
            writer.tag(7, WireType.Varint).bool(message.authorized);
        /* int32 authorization_basis_id = 8; */
        if (message.authorizationBasisId !== 0)
            writer.tag(8, WireType.Varint).int32(message.authorizationBasisId);
        /* string authorized_at = 9; */
        if (message.authorizedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.authorizedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCard
 */
export const HelcimCard = new HelcimCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardList$Type extends MessageType {
    constructor() {
        super("HelcimCardList", [
            { no: 1, name: "cards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimCard },
            { no: 2, name: "aggregate_status", kind: "enum", T: () => ["AggregateCardStatus", AggregateCardStatus] },
            { no: 3, name: "preferred_card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.cards = [];
        message.aggregateStatus = 0;
        message.preferredCardToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated HelcimCard cards */ 1:
                    message.cards.push(HelcimCard.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* AggregateCardStatus aggregate_status */ 2:
                    message.aggregateStatus = reader.int32();
                    break;
                case /* string preferred_card_token */ 3:
                    message.preferredCardToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated HelcimCard cards = 1; */
        for (let i = 0; i < message.cards.length; i++)
            HelcimCard.internalBinaryWrite(message.cards[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* AggregateCardStatus aggregate_status = 2; */
        if (message.aggregateStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.aggregateStatus);
        /* string preferred_card_token = 3; */
        if (message.preferredCardToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.preferredCardToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardList
 */
export const HelcimCardList = new HelcimCardList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchHelcimProfilesReq$Type extends MessageType {
    constructor() {
        super("SearchHelcimProfilesReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchHelcimProfilesReq
 */
export const SearchHelcimProfilesReq = new SearchHelcimProfilesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimProfile$Type extends MessageType {
    constructor() {
        super("HelcimProfile", [
            { no: 1, name: "helcim_customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "customer_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "cards", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimCard },
            { no: 8, name: "link_state", kind: "enum", T: () => ["ProfileLinkState", ProfileLinkState] },
            { no: 9, name: "linked_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.helcimCustomerId = 0;
        message.customerCode = "";
        message.contactName = "";
        message.businessName = "";
        message.email = "";
        message.phone = "";
        message.cards = [];
        message.linkState = 0;
        message.linkedUserId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 helcim_customer_id */ 1:
                    message.helcimCustomerId = reader.int32();
                    break;
                case /* string customer_code */ 2:
                    message.customerCode = reader.string();
                    break;
                case /* string contact_name */ 3:
                    message.contactName = reader.string();
                    break;
                case /* string business_name */ 4:
                    message.businessName = reader.string();
                    break;
                case /* string email */ 5:
                    message.email = reader.string();
                    break;
                case /* string phone */ 6:
                    message.phone = reader.string();
                    break;
                case /* repeated HelcimCard cards */ 7:
                    message.cards.push(HelcimCard.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProfileLinkState link_state */ 8:
                    message.linkState = reader.int32();
                    break;
                case /* int32 linked_user_id */ 9:
                    message.linkedUserId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 helcim_customer_id = 1; */
        if (message.helcimCustomerId !== 0)
            writer.tag(1, WireType.Varint).int32(message.helcimCustomerId);
        /* string customer_code = 2; */
        if (message.customerCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerCode);
        /* string contact_name = 3; */
        if (message.contactName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.contactName);
        /* string business_name = 4; */
        if (message.businessName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.businessName);
        /* string email = 5; */
        if (message.email !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.email);
        /* string phone = 6; */
        if (message.phone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.phone);
        /* repeated HelcimCard cards = 7; */
        for (let i = 0; i < message.cards.length; i++)
            HelcimCard.internalBinaryWrite(message.cards[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProfileLinkState link_state = 8; */
        if (message.linkState !== 0)
            writer.tag(8, WireType.Varint).int32(message.linkState);
        /* int32 linked_user_id = 9; */
        if (message.linkedUserId !== 0)
            writer.tag(9, WireType.Varint).int32(message.linkedUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimProfile
 */
export const HelcimProfile = new HelcimProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimProfileList$Type extends MessageType {
    constructor() {
        super("HelcimProfileList", [
            { no: 1, name: "profiles", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimProfile },
            { no: 2, name: "truncated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.profiles = [];
        message.truncated = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated HelcimProfile profiles */ 1:
                    message.profiles.push(HelcimProfile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool truncated */ 2:
                    message.truncated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated HelcimProfile profiles = 1; */
        for (let i = 0; i < message.profiles.length; i++)
            HelcimProfile.internalBinaryWrite(message.profiles[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool truncated = 2; */
        if (message.truncated !== false)
            writer.tag(2, WireType.Varint).bool(message.truncated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimProfileList
 */
export const HelcimProfileList = new HelcimProfileList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkHelcimProfileReq$Type extends MessageType {
    constructor() {
        super("LinkHelcimProfileReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "helcim_customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "relink", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.helcimCustomerId = 0;
        message.relink = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 helcim_customer_id */ 2:
                    message.helcimCustomerId = reader.int32();
                    break;
                case /* bool relink */ 3:
                    message.relink = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 helcim_customer_id = 2; */
        if (message.helcimCustomerId !== 0)
            writer.tag(2, WireType.Varint).int32(message.helcimCustomerId);
        /* bool relink = 3; */
        if (message.relink !== false)
            writer.tag(3, WireType.Varint).bool(message.relink);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LinkHelcimProfileReq
 */
export const LinkHelcimProfileReq = new LinkHelcimProfileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkHelcimProfileReq$Type extends MessageType {
    constructor() {
        super("UnlinkHelcimProfileReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnlinkHelcimProfileReq
 */
export const UnlinkHelcimProfileReq = new UnlinkHelcimProfileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveHelcimCardReq$Type extends MessageType {
    constructor() {
        super("RemoveHelcimCardReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.cardToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string card_token */ 2:
                    message.cardToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string card_token = 2; */
        if (message.cardToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cardToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveHelcimCardReq
 */
export const RemoveHelcimCardReq = new RemoveHelcimCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHelcimPlanReq$Type extends MessageType {
    constructor() {
        super("GetHelcimPlanReq", [
            { no: 1, name: "plan_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.planId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 plan_id */ 1:
                    message.planId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 plan_id = 1; */
        if (message.planId !== 0)
            writer.tag(1, WireType.Varint).int32(message.planId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetHelcimPlanReq
 */
export const GetHelcimPlanReq = new GetHelcimPlanReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHelcimAddonReq$Type extends MessageType {
    constructor() {
        super("GetHelcimAddonReq", [
            { no: 1, name: "addon_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.addonId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 addon_id */ 1:
                    message.addonId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 addon_id = 1; */
        if (message.addonId !== 0)
            writer.tag(1, WireType.Varint).int32(message.addonId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetHelcimAddonReq
 */
export const GetHelcimAddonReq = new GetHelcimAddonReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimPlan$Type extends MessageType {
    constructor() {
        super("HelcimPlan", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "setup_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "recurring_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "billing_period", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "billing_period_increments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "date_billing", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "term_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "free_trial_period", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "tax_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "term_length", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "add_on_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.dateCreated = "";
        message.dateUpdated = "";
        message.userId = 0;
        message.name = "";
        message.description = "";
        message.type = "";
        message.status = "";
        message.currency = "";
        message.setupAmount = 0;
        message.recurringAmount = 0;
        message.billingPeriod = "";
        message.billingPeriodIncrements = 0;
        message.dateBilling = "";
        message.termType = "";
        message.freeTrialPeriod = 0;
        message.taxType = "";
        message.termLength = 0;
        message.paymentMethod = "";
        message.addOnIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string date_created */ 2:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_updated */ 3:
                    message.dateUpdated = reader.string();
                    break;
                case /* int32 user_id */ 4:
                    message.userId = reader.int32();
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                case /* string status */ 8:
                    message.status = reader.string();
                    break;
                case /* string currency */ 9:
                    message.currency = reader.string();
                    break;
                case /* double setup_amount */ 10:
                    message.setupAmount = reader.double();
                    break;
                case /* double recurring_amount */ 11:
                    message.recurringAmount = reader.double();
                    break;
                case /* string billing_period */ 12:
                    message.billingPeriod = reader.string();
                    break;
                case /* int32 billing_period_increments */ 13:
                    message.billingPeriodIncrements = reader.int32();
                    break;
                case /* string date_billing */ 14:
                    message.dateBilling = reader.string();
                    break;
                case /* string term_type */ 15:
                    message.termType = reader.string();
                    break;
                case /* int32 free_trial_period */ 16:
                    message.freeTrialPeriod = reader.int32();
                    break;
                case /* string tax_type */ 17:
                    message.taxType = reader.string();
                    break;
                case /* int32 term_length */ 18:
                    message.termLength = reader.int32();
                    break;
                case /* string payment_method */ 19:
                    message.paymentMethod = reader.string();
                    break;
                case /* repeated int32 add_on_ids */ 20:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.addOnIds.push(reader.int32());
                    else
                        message.addOnIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string date_created = 2; */
        if (message.dateCreated !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_updated = 3; */
        if (message.dateUpdated !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dateUpdated);
        /* int32 user_id = 4; */
        if (message.userId !== 0)
            writer.tag(4, WireType.Varint).int32(message.userId);
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        /* string status = 8; */
        if (message.status !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.status);
        /* string currency = 9; */
        if (message.currency !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.currency);
        /* double setup_amount = 10; */
        if (message.setupAmount !== 0)
            writer.tag(10, WireType.Bit64).double(message.setupAmount);
        /* double recurring_amount = 11; */
        if (message.recurringAmount !== 0)
            writer.tag(11, WireType.Bit64).double(message.recurringAmount);
        /* string billing_period = 12; */
        if (message.billingPeriod !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.billingPeriod);
        /* int32 billing_period_increments = 13; */
        if (message.billingPeriodIncrements !== 0)
            writer.tag(13, WireType.Varint).int32(message.billingPeriodIncrements);
        /* string date_billing = 14; */
        if (message.dateBilling !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.dateBilling);
        /* string term_type = 15; */
        if (message.termType !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.termType);
        /* int32 free_trial_period = 16; */
        if (message.freeTrialPeriod !== 0)
            writer.tag(16, WireType.Varint).int32(message.freeTrialPeriod);
        /* string tax_type = 17; */
        if (message.taxType !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.taxType);
        /* int32 term_length = 18; */
        if (message.termLength !== 0)
            writer.tag(18, WireType.Varint).int32(message.termLength);
        /* string payment_method = 19; */
        if (message.paymentMethod !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.paymentMethod);
        /* repeated int32 add_on_ids = 20; */
        if (message.addOnIds.length) {
            writer.tag(20, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.addOnIds.length; i++)
                writer.int32(message.addOnIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimPlan
 */
export const HelcimPlan = new HelcimPlan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimAddon$Type extends MessageType {
    constructor() {
        super("HelcimAddon", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "frequency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_quantity_editable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.dateCreated = "";
        message.dateUpdated = "";
        message.name = "";
        message.description = "";
        message.amount = 0;
        message.frequency = "";
        message.isQuantityEditable = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string date_created */ 2:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_updated */ 3:
                    message.dateUpdated = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* double amount */ 6:
                    message.amount = reader.double();
                    break;
                case /* string frequency */ 7:
                    message.frequency = reader.string();
                    break;
                case /* bool is_quantity_editable */ 8:
                    message.isQuantityEditable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string date_created = 2; */
        if (message.dateCreated !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_updated = 3; */
        if (message.dateUpdated !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dateUpdated);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* double amount = 6; */
        if (message.amount !== 0)
            writer.tag(6, WireType.Bit64).double(message.amount);
        /* string frequency = 7; */
        if (message.frequency !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.frequency);
        /* bool is_quantity_editable = 8; */
        if (message.isQuantityEditable !== false)
            writer.tag(8, WireType.Varint).bool(message.isQuantityEditable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimAddon
 */
export const HelcimAddon = new HelcimAddon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimPlanWithAddons$Type extends MessageType {
    constructor() {
        super("HelcimPlanWithAddons", [
            { no: 1, name: "plan", kind: "message", T: () => HelcimPlan },
            { no: 2, name: "addons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimAddon }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.addons = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* HelcimPlan plan */ 1:
                    message.plan = HelcimPlan.internalBinaryRead(reader, reader.uint32(), options, message.plan);
                    break;
                case /* repeated HelcimAddon addons */ 2:
                    message.addons.push(HelcimAddon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* HelcimPlan plan = 1; */
        if (message.plan)
            HelcimPlan.internalBinaryWrite(message.plan, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated HelcimAddon addons = 2; */
        for (let i = 0; i < message.addons.length; i++)
            HelcimAddon.internalBinaryWrite(message.addons[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimPlanWithAddons
 */
export const HelcimPlanWithAddons = new HelcimPlanWithAddons$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCardReadersReq$Type extends MessageType {
    constructor() {
        super("ListCardReadersReq", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListCardReadersReq
 */
export const ListCardReadersReq = new ListCardReadersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardReader$Type extends MessageType {
    constructor() {
        super("CardReader", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.code = "";
        message.status = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                case /* string label */ 4:
                    message.label = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        /* string label = 4; */
        if (message.label !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.label);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CardReader
 */
export const CardReader = new CardReader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CardReaderList$Type extends MessageType {
    constructor() {
        super("CardReaderList", [
            { no: 1, name: "readers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CardReader }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.readers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CardReader readers */ 1:
                    message.readers.push(CardReader.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CardReader readers = 1; */
        for (let i = 0; i < message.readers.length; i++)
            CardReader.internalBinaryWrite(message.readers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CardReaderList
 */
export const CardReaderList = new CardReaderList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartTerminalCaptureReq$Type extends MessageType {
    constructor() {
        super("StartTerminalCaptureReq", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "partial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.userId = 0;
        message.amount = 0;
        message.deviceId = "";
        message.currency = "";
        message.partial = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* float amount */ 3:
                    message.amount = reader.float();
                    break;
                case /* string device_id */ 4:
                    message.deviceId = reader.string();
                    break;
                case /* string currency */ 5:
                    message.currency = reader.string();
                    break;
                case /* bool partial */ 6:
                    message.partial = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* float amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit32).float(message.amount);
        /* string device_id = 4; */
        if (message.deviceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.deviceId);
        /* string currency = 5; */
        if (message.currency !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.currency);
        /* bool partial = 6; */
        if (message.partial !== false)
            writer.tag(6, WireType.Varint).bool(message.partial);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StartTerminalCaptureReq
 */
export const StartTerminalCaptureReq = new StartTerminalCaptureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartTerminalCaptureResp$Type extends MessageType {
    constructor() {
        super("StartTerminalCaptureResp", [
            { no: 1, name: "helcim_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.helcimEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 helcim_event_id */ 1:
                    message.helcimEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 helcim_event_id = 1; */
        if (message.helcimEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.helcimEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StartTerminalCaptureResp
 */
export const StartTerminalCaptureResp = new StartTerminalCaptureResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelTerminalCaptureReq$Type extends MessageType {
    constructor() {
        super("CancelTerminalCaptureReq", [
            { no: 1, name: "helcim_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.helcimEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 helcim_event_id */ 1:
                    message.helcimEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 helcim_event_id = 1; */
        if (message.helcimEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.helcimEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelTerminalCaptureReq
 */
export const CancelTerminalCaptureReq = new CancelTerminalCaptureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChargeCardOnFileReq$Type extends MessageType {
    constructor() {
        super("ChargeCardOnFileReq", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "card_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "partial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.userId = 0;
        message.amount = 0;
        message.cardToken = "";
        message.currency = "";
        message.partial = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* float amount */ 3:
                    message.amount = reader.float();
                    break;
                case /* string card_token */ 4:
                    message.cardToken = reader.string();
                    break;
                case /* string currency */ 5:
                    message.currency = reader.string();
                    break;
                case /* bool partial */ 6:
                    message.partial = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* float amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit32).float(message.amount);
        /* string card_token = 4; */
        if (message.cardToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cardToken);
        /* string currency = 5; */
        if (message.currency !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.currency);
        /* bool partial = 6; */
        if (message.partial !== false)
            writer.tag(6, WireType.Varint).bool(message.partial);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChargeCardOnFileReq
 */
export const ChargeCardOnFileReq = new ChargeCardOnFileReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChargeCardOnFileResp$Type extends MessageType {
    constructor() {
        super("ChargeCardOnFileResp", [
            { no: 1, name: "helcim_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "helcim_transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "card_last4", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.helcimEventId = 0;
        message.status = "";
        message.helcimTransactionId = 0;
        message.errorMessage = "";
        message.cardLast4 = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 helcim_event_id */ 1:
                    message.helcimEventId = reader.int32();
                    break;
                case /* string status */ 2:
                    message.status = reader.string();
                    break;
                case /* int32 helcim_transaction_id */ 3:
                    message.helcimTransactionId = reader.int32();
                    break;
                case /* string error_message */ 4:
                    message.errorMessage = reader.string();
                    break;
                case /* string card_last4 */ 5:
                    message.cardLast4 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 helcim_event_id = 1; */
        if (message.helcimEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.helcimEventId);
        /* string status = 2; */
        if (message.status !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.status);
        /* int32 helcim_transaction_id = 3; */
        if (message.helcimTransactionId !== 0)
            writer.tag(3, WireType.Varint).int32(message.helcimTransactionId);
        /* string error_message = 4; */
        if (message.errorMessage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.errorMessage);
        /* string card_last4 = 5; */
        if (message.cardLast4 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cardLast4);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChargeCardOnFileResp
 */
export const ChargeCardOnFileResp = new ChargeCardOnFileResp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubscriptionReq$Type extends MessageType {
    constructor() {
        super("CreateSubscriptionReq", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "payment_plan_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "recurring_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "date_activated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.paymentPlanId = 0;
        message.recurringAmount = 0;
        message.dateActivated = "";
        message.paymentMethod = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 payment_plan_id */ 2:
                    message.paymentPlanId = reader.int32();
                    break;
                case /* double recurring_amount */ 3:
                    message.recurringAmount = reader.double();
                    break;
                case /* string date_activated */ 4:
                    message.dateActivated = reader.string();
                    break;
                case /* string payment_method */ 5:
                    message.paymentMethod = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 payment_plan_id = 2; */
        if (message.paymentPlanId !== 0)
            writer.tag(2, WireType.Varint).int32(message.paymentPlanId);
        /* double recurring_amount = 3; */
        if (message.recurringAmount !== 0)
            writer.tag(3, WireType.Bit64).double(message.recurringAmount);
        /* string date_activated = 4; */
        if (message.dateActivated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateActivated);
        /* string payment_method = 5; */
        if (message.paymentMethod !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentMethod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubscriptionReq
 */
export const CreateSubscriptionReq = new CreateSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelSubscriptionReq$Type extends MessageType {
    constructor() {
        super("CancelSubscriptionReq", [
            { no: 1, name: "subscription_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriptionId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 subscription_id */ 1:
                    message.subscriptionId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 subscription_id = 1; */
        if (message.subscriptionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.subscriptionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelSubscriptionReq
 */
export const CancelSubscriptionReq = new CancelSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubscriptionReq$Type extends MessageType {
    constructor() {
        super("GetSubscriptionReq", [
            { no: 1, name: "subscription_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriptionId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 subscription_id */ 1:
                    message.subscriptionId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 subscription_id = 1; */
        if (message.subscriptionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.subscriptionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSubscriptionReq
 */
export const GetSubscriptionReq = new GetSubscriptionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimSubscriptionPayment$Type extends MessageType {
    constructor() {
        super("HelcimSubscriptionPayment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "setup_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "recurring_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "add_on_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "tax_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "date_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "date_processed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "payment_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "number_of_retries", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.setupAmount = 0;
        message.recurringAmount = 0;
        message.addOnAmount = 0;
        message.amount = 0;
        message.taxAmount = 0;
        message.dateDue = "";
        message.dateProcessed = "";
        message.status = "";
        message.paymentNumber = 0;
        message.numberOfRetries = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* double setup_amount */ 2:
                    message.setupAmount = reader.double();
                    break;
                case /* double recurring_amount */ 3:
                    message.recurringAmount = reader.double();
                    break;
                case /* double add_on_amount */ 4:
                    message.addOnAmount = reader.double();
                    break;
                case /* double amount */ 5:
                    message.amount = reader.double();
                    break;
                case /* double tax_amount */ 6:
                    message.taxAmount = reader.double();
                    break;
                case /* string date_due */ 7:
                    message.dateDue = reader.string();
                    break;
                case /* string date_processed */ 8:
                    message.dateProcessed = reader.string();
                    break;
                case /* string status */ 9:
                    message.status = reader.string();
                    break;
                case /* int32 payment_number */ 10:
                    message.paymentNumber = reader.int32();
                    break;
                case /* int32 number_of_retries */ 11:
                    message.numberOfRetries = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* double setup_amount = 2; */
        if (message.setupAmount !== 0)
            writer.tag(2, WireType.Bit64).double(message.setupAmount);
        /* double recurring_amount = 3; */
        if (message.recurringAmount !== 0)
            writer.tag(3, WireType.Bit64).double(message.recurringAmount);
        /* double add_on_amount = 4; */
        if (message.addOnAmount !== 0)
            writer.tag(4, WireType.Bit64).double(message.addOnAmount);
        /* double amount = 5; */
        if (message.amount !== 0)
            writer.tag(5, WireType.Bit64).double(message.amount);
        /* double tax_amount = 6; */
        if (message.taxAmount !== 0)
            writer.tag(6, WireType.Bit64).double(message.taxAmount);
        /* string date_due = 7; */
        if (message.dateDue !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateDue);
        /* string date_processed = 8; */
        if (message.dateProcessed !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dateProcessed);
        /* string status = 9; */
        if (message.status !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.status);
        /* int32 payment_number = 10; */
        if (message.paymentNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.paymentNumber);
        /* int32 number_of_retries = 11; */
        if (message.numberOfRetries !== 0)
            writer.tag(11, WireType.Varint).int32(message.numberOfRetries);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimSubscriptionPayment
 */
export const HelcimSubscriptionPayment = new HelcimSubscriptionPayment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimSubscriptionWithPayments$Type extends MessageType {
    constructor() {
        super("HelcimSubscriptionWithPayments", [
            { no: 1, name: "subscription", kind: "message", T: () => HelcimSubscription },
            { no: 2, name: "payments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HelcimSubscriptionPayment }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.payments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* HelcimSubscription subscription */ 1:
                    message.subscription = HelcimSubscription.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
                    break;
                case /* repeated HelcimSubscriptionPayment payments */ 2:
                    message.payments.push(HelcimSubscriptionPayment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* HelcimSubscription subscription = 1; */
        if (message.subscription)
            HelcimSubscription.internalBinaryWrite(message.subscription, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated HelcimSubscriptionPayment payments = 2; */
        for (let i = 0; i < message.payments.length; i++)
            HelcimSubscriptionPayment.internalBinaryWrite(message.payments[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimSubscriptionWithPayments
 */
export const HelcimSubscriptionWithPayments = new HelcimSubscriptionWithPayments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimSubscription$Type extends MessageType {
    constructor() {
        super("HelcimSubscription", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "date_activated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_billing", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "payment_plan_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "customer_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "times_billed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "setup_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "recurring_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "free_trial_period", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "max_cycles", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "add_on_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.dateCreated = "";
        message.dateUpdated = "";
        message.dateActivated = "";
        message.dateBilling = "";
        message.status = "";
        message.paymentPlanId = 0;
        message.customerCode = "";
        message.timesBilled = 0;
        message.setupAmount = 0;
        message.recurringAmount = 0;
        message.freeTrialPeriod = 0;
        message.maxCycles = 0;
        message.addOnIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string date_created */ 2:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_updated */ 3:
                    message.dateUpdated = reader.string();
                    break;
                case /* string date_activated */ 4:
                    message.dateActivated = reader.string();
                    break;
                case /* string date_billing */ 5:
                    message.dateBilling = reader.string();
                    break;
                case /* string status */ 6:
                    message.status = reader.string();
                    break;
                case /* int32 payment_plan_id */ 7:
                    message.paymentPlanId = reader.int32();
                    break;
                case /* string customer_code */ 8:
                    message.customerCode = reader.string();
                    break;
                case /* int32 times_billed */ 9:
                    message.timesBilled = reader.int32();
                    break;
                case /* double setup_amount */ 10:
                    message.setupAmount = reader.double();
                    break;
                case /* double recurring_amount */ 11:
                    message.recurringAmount = reader.double();
                    break;
                case /* int32 free_trial_period */ 12:
                    message.freeTrialPeriod = reader.int32();
                    break;
                case /* int32 max_cycles */ 13:
                    message.maxCycles = reader.int32();
                    break;
                case /* repeated int32 add_on_ids */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.addOnIds.push(reader.int32());
                    else
                        message.addOnIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string date_created = 2; */
        if (message.dateCreated !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_updated = 3; */
        if (message.dateUpdated !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dateUpdated);
        /* string date_activated = 4; */
        if (message.dateActivated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateActivated);
        /* string date_billing = 5; */
        if (message.dateBilling !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateBilling);
        /* string status = 6; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        /* int32 payment_plan_id = 7; */
        if (message.paymentPlanId !== 0)
            writer.tag(7, WireType.Varint).int32(message.paymentPlanId);
        /* string customer_code = 8; */
        if (message.customerCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customerCode);
        /* int32 times_billed = 9; */
        if (message.timesBilled !== 0)
            writer.tag(9, WireType.Varint).int32(message.timesBilled);
        /* double setup_amount = 10; */
        if (message.setupAmount !== 0)
            writer.tag(10, WireType.Bit64).double(message.setupAmount);
        /* double recurring_amount = 11; */
        if (message.recurringAmount !== 0)
            writer.tag(11, WireType.Bit64).double(message.recurringAmount);
        /* int32 free_trial_period = 12; */
        if (message.freeTrialPeriod !== 0)
            writer.tag(12, WireType.Varint).int32(message.freeTrialPeriod);
        /* int32 max_cycles = 13; */
        if (message.maxCycles !== 0)
            writer.tag(13, WireType.Varint).int32(message.maxCycles);
        /* repeated int32 add_on_ids = 14; */
        if (message.addOnIds.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.addOnIds.length; i++)
                writer.int32(message.addOnIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimSubscription
 */
export const HelcimSubscription = new HelcimSubscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LookupPrepaidTransactionReq$Type extends MessageType {
    constructor() {
        super("LookupPrepaidTransactionReq", [
            { no: 1, name: "helcim_transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.helcimTransactionId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 helcim_transaction_id */ 1:
                    message.helcimTransactionId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 helcim_transaction_id = 1; */
        if (message.helcimTransactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.helcimTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LookupPrepaidTransactionReq
 */
export const LookupPrepaidTransactionReq = new LookupPrepaidTransactionReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HelcimCardTransaction$Type extends MessageType {
    constructor() {
        super("HelcimCardTransaction", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "customer_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionId = 0;
        message.status = "";
        message.amount = 0;
        message.customerCode = "";
        message.dateCreated = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 transaction_id */ 1:
                    message.transactionId = reader.int32();
                    break;
                case /* string status */ 2:
                    message.status = reader.string();
                    break;
                case /* double amount */ 3:
                    message.amount = reader.double();
                    break;
                case /* string customer_code */ 4:
                    message.customerCode = reader.string();
                    break;
                case /* string date_created */ 5:
                    message.dateCreated = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.transactionId);
        /* string status = 2; */
        if (message.status !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.status);
        /* double amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit64).double(message.amount);
        /* string customer_code = 4; */
        if (message.customerCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerCode);
        /* string date_created = 5; */
        if (message.dateCreated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateCreated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HelcimCardTransaction
 */
export const HelcimCardTransaction = new HelcimCardTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrepaidTransactionLookup$Type extends MessageType {
    constructor() {
        super("PrepaidTransactionLookup", [
            { no: 1, name: "transaction", kind: "message", T: () => HelcimCardTransaction },
            { no: 2, name: "subscription", kind: "message", T: () => HelcimSubscription }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* HelcimCardTransaction transaction */ 1:
                    message.transaction = HelcimCardTransaction.internalBinaryRead(reader, reader.uint32(), options, message.transaction);
                    break;
                case /* HelcimSubscription subscription */ 2:
                    message.subscription = HelcimSubscription.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* HelcimCardTransaction transaction = 1; */
        if (message.transaction)
            HelcimCardTransaction.internalBinaryWrite(message.transaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* HelcimSubscription subscription = 2; */
        if (message.subscription)
            HelcimSubscription.internalBinaryWrite(message.subscription, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PrepaidTransactionLookup
 */
export const PrepaidTransactionLookup = new PrepaidTransactionLookup$Type();
/**
 * @generated ServiceType for protobuf service HelcimService
 */
export const HelcimService = new ServiceType("HelcimService", [
    { name: "CreateCheckoutSession", options: {}, I: CheckoutReq, O: CheckoutResp },
    { name: "CreateCheckoutPartialPayment", options: {}, I: CheckoutReq, O: CheckoutResp },
    { name: "CreateVerifyCardCheckoutSession", options: {}, I: VerifyCardCheckoutReq, O: CheckoutResp },
    { name: "ListCardsOnFile", options: {}, I: ListCardsOnFileReq, O: HelcimCardList },
    { name: "SetPreferredHelcimCard", options: {}, I: SetPreferredHelcimCardReq, O: Empty },
    { name: "SearchHelcimProfiles", options: {}, I: SearchHelcimProfilesReq, O: HelcimProfileList },
    { name: "LinkHelcimProfile", options: {}, I: LinkHelcimProfileReq, O: HelcimCardList },
    { name: "UnlinkHelcimProfile", options: {}, I: UnlinkHelcimProfileReq, O: Empty },
    { name: "RemoveHelcimCard", options: {}, I: RemoveHelcimCardReq, O: HelcimCardList },
    { name: "CreateHelcimEvent", options: {}, I: HelcimEvent, O: HelcimEvent },
    { name: "GetHelcimEvent", options: {}, I: HelcimEvent, O: HelcimEvent },
    { name: "BatchGetHelcimEvent", options: {}, I: HelcimEvent, O: HelcimEventList },
    { name: "UpdateHelcimEvent", options: {}, I: HelcimEvent, O: HelcimEvent },
    { name: "DeleteHelcimEvent", options: {}, I: HelcimEvent, O: Empty },
    { name: "CreateHelcimCardAuthorization", options: {}, I: HelcimCardAuthorization, O: HelcimCardAuthorization },
    { name: "GetHelcimCardAuthorization", options: {}, I: HelcimCardAuthorization, O: HelcimCardAuthorization },
    { name: "BatchGetHelcimCardAuthorization", options: {}, I: HelcimCardAuthorization, O: HelcimCardAuthorizationList },
    { name: "UpdateHelcimCardAuthorization", options: {}, I: HelcimCardAuthorization, O: HelcimCardAuthorization },
    { name: "DeleteHelcimCardAuthorization", options: {}, I: HelcimCardAuthorization, O: Empty },
    { name: "CreateHelcimCardAudit", options: {}, I: HelcimCardAudit, O: HelcimCardAudit },
    { name: "GetHelcimCardAudit", options: {}, I: HelcimCardAudit, O: HelcimCardAudit },
    { name: "BatchGetHelcimCardAudit", options: {}, I: HelcimCardAudit, O: HelcimCardAuditList },
    { name: "CreateCardOnFileLink", options: {}, I: CreateCardOnFileLinkReq, O: CardOnFileLinkResp },
    { name: "GetCardLinkStatus", options: {}, I: GetCardLinkStatusReq, O: CardLinkStatus },
    { name: "ResendCardOnFileLink", options: {}, I: ResendCardOnFileLinkReq, O: CardOnFileLinkResp },
    { name: "CancelCardOnFileLink", options: {}, I: CancelCardOnFileLinkReq, O: Empty },
    { name: "AuthorizeCards", options: {}, I: AuthorizeCardsReq, O: HelcimCardList },
    { name: "CompleteCardSave", options: {}, I: CompleteCardSaveReq, O: HelcimCardList },
    { name: "GetPublicCardLinkData", options: {}, I: PublicCardLinkReq, O: PublicCardLinkData },
    { name: "CompletePublicCardSave", options: {}, I: PublicCardLinkReq, O: PublicCardLinkData },
    { name: "PublicAuthorizeCard", options: {}, I: PublicCardActionReq, O: PublicCardLinkData },
    { name: "PublicRemoveCard", options: {}, I: PublicCardActionReq, O: PublicCardLinkData },
    { name: "GetHelcimPlan", options: {}, I: GetHelcimPlanReq, O: HelcimPlan },
    { name: "GetHelcimAddon", options: {}, I: GetHelcimAddonReq, O: HelcimAddon },
    { name: "GetHelcimPlanWithAddons", options: {}, I: GetHelcimPlanReq, O: HelcimPlanWithAddons },
    { name: "CreateSubscription", options: {}, I: CreateSubscriptionReq, O: HelcimSubscription },
    { name: "CancelSubscription", options: {}, I: CancelSubscriptionReq, O: Empty },
    { name: "GetSubscription", options: {}, I: GetSubscriptionReq, O: HelcimSubscriptionWithPayments },
    { name: "LookupPrepaidTransaction", options: {}, I: LookupPrepaidTransactionReq, O: PrepaidTransactionLookup },
    { name: "ListCardReaders", options: {}, I: ListCardReadersReq, O: CardReaderList },
    { name: "StartTerminalCapture", options: {}, I: StartTerminalCaptureReq, O: StartTerminalCaptureResp },
    { name: "CancelTerminalCapture", options: {}, I: CancelTerminalCaptureReq, O: Empty },
    { name: "ChargeCardOnFile", options: {}, I: ChargeCardOnFileReq, O: ChargeCardOnFileResp }
]);
